<ion-app>
  <ion-router-outlet [animation]="defaultPageTransition"></ion-router-outlet>
</ion-app>